import axiosInstance from '../lib/axios';

interface DraftCasePayload {
  rrms_ref_number?: string;
  cms_number?: string;
  district?: string;
  ps_name?: string;
  fir_number?: string;
  case_type?: string;
  case_type_code?: string;
  year?: number;
  case_status?: string;
  division_id?: number;
  department_id?: number;
  state?: string;
  fir_registration_date?: string;
  final_report_status?: string;
  office_of?: string;
  letter_no?: string;
  addressed_to?: string;
  author?: string;
}

interface DraftDocumentPayload {
  folder_type?: string;
  document_type?: string;
  classification?: string;
  hashtags?: string[];
}

interface DraftFileMetadata {
  folder_type?: string;
  document_type?: string;
  classification?: string;
  hashtags?: string[];
}

interface ExistingDraftDocumentMetadata extends DraftFileMetadata {
  rrms_document_draft_id: string;
}

function appendDraftFormData(
  files: File[],
  caseData: DraftCasePayload,
  documentData: DraftDocumentPayload,
  metadata: DraftFileMetadata[] = [],
  existingDocumentMetadata: ExistingDraftDocumentMetadata[] = []
) {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));
  formData.append('case_data', JSON.stringify(caseData || {}));
  formData.append('document_data', JSON.stringify(documentData || {}));
  formData.append('metadata', JSON.stringify(metadata || []));
  formData.append(
    'existing_document_metadata',
    JSON.stringify(existingDocumentMetadata || [])
  );
  return formData;
}

const draftService = {
  createDraft: (
    files: File[],
    caseData: DraftCasePayload,
    documentData: DraftDocumentPayload,
    metadata: DraftFileMetadata[] = [],
    existingDocumentMetadata: ExistingDraftDocumentMetadata[] = []
  ) =>
    axiosInstance.post(
      '/drafts',
      appendDraftFormData(
        files,
        caseData,
        documentData,
        metadata,
        existingDocumentMetadata
      ),
      {
      headers: { 'Content-Type': 'multipart/form-data' },
      }
    ),

  updateDraft: (
    draftId: string,
    files: File[],
    caseData: DraftCasePayload,
    documentData: DraftDocumentPayload,
    metadata: DraftFileMetadata[] = [],
    existingDocumentMetadata: ExistingDraftDocumentMetadata[] = []
  ) =>
    axiosInstance.put(
      `/drafts/${draftId}`,
      appendDraftFormData(
        files,
        caseData,
        documentData,
        metadata,
        existingDocumentMetadata
      ),
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    ),

  getDrafts: (params: { page?: number; limit?: number }) =>
    axiosInstance.get('/drafts', { params }),

  getDraftById: (draftId: string) => axiosInstance.get(`/drafts/${draftId}`),

  deleteDraftDocument: (draftId: string, documentDraftId: string) =>
    axiosInstance.delete(`/drafts/${draftId}/documents/${documentDraftId}`),

  submitDraft: (draftId: string) => axiosInstance.post(`/drafts/${draftId}/submit`),
};

export default draftService;

